import React, { useEffect, useState } from 'react';
import classes from "./SuccessPage.module.css";
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { checkSubscriptionApi } from '../Http/http';
import { toast } from 'react-toastify';

const DeactivateProcessing = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const checkSubscription = async () => {
        try {
            setLoading(true);

            const responseLogin = await checkSubscriptionApi({ msisdn: Cookies.get("msisdn") });

            console.log(responseLogin?.data?.result);

            if (responseLogin?.data?.result?.statusCode == 403) {
                console.log("not subscribed");
                Cookies.remove("msisdn");
                toast.success("Deactivation Successful!");
                navigate("/deactivation-success")
                return;
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!loading && Cookies.get("msisdn")) {
            const apiInterval = setInterval(() => {
                checkSubscription();
            }, 2000);
            return () => {
                clearInterval(apiInterval);
            }
        }
    }, [loading]);

    return (
        <div className={classes.wrapper}>
            <div className={classes.statusContainer}>
                <AiOutlineLoading3Quarters className={classes.iconLoading} />
                <h2>Deactivating...</h2>
                <p>Please wait while we process your deactivation.</p>
            </div>
        </div>
    )
}

export default DeactivateProcessing